import React from 'react';
import './PaymentBadges.css';

// Blue "Invoiced" once a QuickBooks invoice exists; green "Paid" once it is fully paid
// (or marked paid by hand). A paid invoice shows both.
const PaymentBadges = ({ workOrder, showBalance = false }) => {
  if (!workOrder) return null;
  const balance = parseFloat(workOrder.invoice_balance);
  const partlyPaid = showBalance && workOrder.is_invoiced && !workOrder.mark_as_paid
    && balance > 0 && balance < parseFloat(workOrder.price);

  if (!workOrder.is_invoiced && !workOrder.mark_as_paid) return null;
  return (
    <span className="payment-badges">
      {workOrder.is_invoiced && <span className="payment-badge invoiced">Invoiced</span>}
      {workOrder.mark_as_paid && <span className="payment-badge paid">Paid</span>}
      {partlyPaid && <span className="payment-badge-balance">${balance.toFixed(2)} owed</span>}
    </span>
  );
};

export default PaymentBadges;
